import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"
import { reducedMotion } from "../libs/motion"

// One popover per answer, pinned to its first dot, so it holds still while
// the pointer moves across that answer's dots and the gaps between them.
export default class extends Controller {
  static targets = ["dot", "popover"]

  connect() {
    this.popovers = this.popoverTargets.flatMap((template) => {
      const dots = this.dotTargets.filter((dot) => dot.dataset.seriesKey === template.dataset.seriesKey)
      if (dots.length === 0) return []

      return tippy(dots[0], {
        content: template.innerHTML,
        allowHTML: true,
        triggerTarget: dots,
        placement: "top",
        theme: "light",
        // Narrower than the other chart popovers: a long slice name wraps
        // instead of stretching the box over a single answer.
        maxWidth: 224,
        arrow: false,
        // Crossing the gap to a neighbouring dot mustn't close it.
        delay: [0, 100],
        ...(reducedMotion() && { duration: 0 }),
        appendTo: () => document.body,
        popperOptions: {
          modifiers: [
            { name: "flip", options: { boundary: this.element, padding: 8 } },
            { name: "preventOverflow", options: { boundary: this.element, padding: 8, altAxis: true } }
          ]
        },
        onCreate: (instance) => instance.popper.classList.add("tippy-chart"),
        // A wrapped title keeps the width the whole name asked for, so pin it
        // to its longest line and let the box hug that.
        onMount: ({ popper, popperInstance }) => {
          const title = popper.querySelector(".tippy-content p")
          if (!title?.textContent.trim()) return

          title.style.width = ""
          const range = document.createRange()
          range.selectNodeContents(title)
          const longest = Math.max(...[...range.getClientRects()].map((line) => line.width))
          // +1 guards against sub-pixel rounding re-wrapping the last line.
          title.style.width = `${Math.ceil(longest) + 1}px`
          popperInstance?.update()
        }
      })
    })
  }

  disconnect() {
    this.popovers.forEach((popover) => popover.destroy())
  }
}
